module.exports = __webpack_public_path__ + "static/img/SFG108_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SFG108_1.png
// module id = i+og
// module chunks = 0